var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M231,49.7h-40.5l-19.6-21c-0.1-0.1-0.2-0.2-0.3-0.2c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.2-0.1-0.3-0.1c0,0,0,0,0,0  c-0.1,0-0.2,0-0.3,0h-150c-0.8,0-1.5,0.7-1.5,1.5v194c0,11,9,20,20,20h67.2c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H38.4  c-9.4,0-17-7.6-17-17V31.2h147v38c0,0.8,0.7,1.5,1.5,1.5h35.5v159.4c0,4.3,2,8.1,5.1,10.6h-77.6c-0.8,0-1.5,0.7-1.5,1.5  s0.7,1.5,1.5,1.5h86.1c7.5,0,13.6-6.1,13.6-13.6V51.2C232.5,50.3,231.9,49.7,231,49.7z M171.3,33.5l32,34.2h-32V33.5z M229.5,230.1  c0,5.9-4.8,10.6-10.6,10.6s-10.6-4.8-10.6-10.6V69.2c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1c0-0.1,0-0.1-0.1-0.2c0,0,0,0,0-0.1  c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0,0,0c0,0,0,0,0,0l-14.5-15.5h36.2V230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.9,240.7h-5.6c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h5.6c0.8,0,1.5-0.7,1.5-1.5S123.7,240.7,122.9,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,85.5h115.9c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H53.9c-0.8,0-1.5,0.7-1.5,1.5S53.1,85.5,53.9,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,109.1h115.9c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H53.9c-0.8,0-1.5,0.7-1.5,1.5S53.1,109.1,53.9,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,132.6h58c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-58c-0.8,0-1.5,0.7-1.5,1.5S53.1,132.6,53.9,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,156.2h58c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-58c-0.8,0-1.5,0.7-1.5,1.5S53.1,156.2,53.9,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,179.8h115.9c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H53.9c-0.8,0-1.5,0.7-1.5,1.5S53.1,179.8,53.9,179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,203.3h115.9c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H53.9c-0.8,0-1.5,0.7-1.5,1.5S53.1,203.3,53.9,203.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,127.4h-46.9c-0.8,0-1.5,0.7-1.5,1.5v28.5c0,0.8,0.7,1.5,1.5,1.5h46.9c0.8,0,1.5-0.7,1.5-1.5v-28.5  C171.3,128.1,170.7,127.4,169.8,127.4z M168.3,155.9h-43.9v-25.5h43.9V155.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.108d9edb9b896428c94dc4b748bf2b76.svg";
export { ForwardRef as ReactComponent };